<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Visita</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div v-if="isDataLoaded" class="container-fluid mt--6">
      <div class="row justify-content-center">
        <div class="col-md-6 col-sm-12 card-wrapper">
          <div class="card mb-4">
            <!-- Card header -->
            <div class="card-header d-flex justify-content-between">
              <h3 class="mb-0 col-md-6">Datos de la visita</h3>
              <badge
                v-if="$can('private', 'visits') && visit && !visit.share"
                class="float-right"
                type="info"
                v-text="`VISITA PRIVADA`"
              ></badge>
            </div>
            <div class="card-body">
              <!-- datos de la visita -->
              <visit-data :visit="visit"></visit-data>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 card-wrapper">
          <div v-if="$can('index', 'comments')" class="card mb-4">
            <!-- Card header -->
            <div class="card-header">
              <h3 class="mb-0">Comentarios</h3>
            </div>
            <div class="card-body">
              <!-- comentarios -->
              <visit-comments :comments="comments" :visit="visit" @addComment="addCommentToVisit"></visit-comments>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';

import VisitData from './Show/VisitData';
import VisitComments from './Show/VisitComments';

export default {
  name: 'VisitShow',
  components: {
    RouteBreadCrumb,
    VisitData,
    VisitComments,
  },

  data() {
    return {
      visit: {},
      comments: [],
      isDataLoaded: false,
    };
  },

  computed: {},
  created() {
    let visitId = this.$route.params.id;
    this.fetchVisit(visitId);
    this.fetchComments(visitId);
  },

  methods: {
    fetchComments(visitId) {
      this.$services
        .resource('comments')
        .get({ 'filter[visit]': visitId, include: 'user.role' })
        .then((res) => res.data.data)
        .then((data) => (this.comments = data.comments));
    },

    fetchVisit(visitId) {
      this.$services
        .resource('visits')
        .show(visitId, { include: ['participants.participable', 'user.role', 'comments.user.role'] })
        .then((res) => res.data.data)
        .then((visit) => {
          this.visit = visit;
          this.isDataLoaded = true;
        });
    },

    addCommentToVisit(comment) {
      this.$services
        .resource('comments')
        .create(comment)
        .then((res) => {
          this.comments.push(res.data.data);
        });
    },
  },
};
</script>
